import _ from 'lodash';

import {  useRef, useState, useEffect } from 'react';
import { Button, Stack, Chip, Fade, TextField, IconButton } from '@mui/material';

import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { ReactComponent as CloseIcon } from '@/img/icons/x-close-gray.svg';
import { ReactComponent as FilterIcon } from '@/img/icons/filter.svg';

import { getLabel, getFilterName } from './helpers/utils';
import { ArbiIconButton } from '@/components/general/styled/buttons';
import { ReactComponent as SearchIcon } from '@/img/bookings/search.svg';

import { EXTRAS } from './consts';

import NewBookingsFiltersComponent from './NewBookingsFiltersComponent';

const NewBookingsFiltersWrapComponent = ({
	status,
	profile,
	bookings,

	initFilters,
	filters,
	setFilters,

	initPagination,
	setPagination,

	initSort,
	setSort,

	handleDeleteTag,
	search,
	setSearch,
}) => {
	const { t, i18n } = useTranslation();

	const wrapRef = useRef(null);

	const [filtersExpanded, setFiltersExpanded] = useState(false);


	// Close filters on Esc key
	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === 'Escape') {
				setFiltersExpanded(false);
			}
		};

		if (filtersExpanded) {
			window.addEventListener('keydown', handleKeyDown);
		}

		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [filtersExpanded]);

	// Prevent page scroll while filters panel is open
	useEffect(() => {
		if (filtersExpanded) {
			const originalOverflow = document.body.style.overflow;
			document.body.style.overflow = 'hidden';
			return () => {
				document.body.style.overflow = originalOverflow;
			};
		}
	}, [filtersExpanded]);

	const clearAllFilters = () => {
		setPagination(initPagination);
		setSort(initSort);
		setFilters(initFilters);
		setSearch('');
	};

	const filtersAreActive = _.some(filters, (value) => !_.isEmpty(value));

		const onSearchClick = () => {
			if (_.isEmpty(search)) {
				return;
			}
			search = search.trim()
			setPagination(initPagination);
			setSearch(search);
			setFilters({ ...filters, search });
			setFiltersExpanded(false)
		};

		const onSearchEnterClick = (e) => {
		if (e.key === 'Enter') {
			onSearchClick();
		}
	};

	const getTags = () => {
		return Object.keys(filters).map((key, index) => {
			if (
				key === EXTRAS.AGENT_ID ||
				key === EXTRAS.HOTEL_ID
			) {
				return false;
			}

			const filter_name = getFilterName(key, t);

			const label = getLabel(key, filters, t, profile);

			const labelRender = (
				<div className="tag">
					<div>{filter_name}:</div>
					<div>{label}</div>
				</div>
			);

			return (
				!_.isEmpty(filters[key]) && (
					<Chip
						label={labelRender}
						aria-label={`Delete ${filter_name} filter`}
						key={`tag-${index}`}
						onDelete={() => handleDeleteTag(key)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								handleDeleteTag(key);
							}
						}}
						deleteIcon={<CloseIcon />}
					/>
				)
			);
		});
	};

	return (
		<>
			<div
				ref={wrapRef}
				className={classNames('new-bookings-filters-wrap-component', { tags: filtersAreActive })}
			>
				<div className="new-bookings-filters-wrap-component__top-bar">
							<TextField
								// id="search-input"
								className="new-bookings-filters-wrap-component__search"
								placeholder={t('Bookings.Filter.SearchPlaceholder')}
								variant="outlined"
								InputProps={{
									endAdornment: (
										<IconButton aria-label="Search" onClick={onSearchClick}>
											<SearchIcon />
										</IconButton>
									),
								}}
								value={search}
								onChange={(e) => setSearch(e.target.value.replace(/ +/g,' ').replace(/[^A-Za-z0-9 -]/g, ''))}
								onKeyDown={onSearchEnterClick}
							/>
					<ArbiIconButton
						startIcon={<FilterIcon />}
						sx={{
							width: 164,
							height: 34,
							...(filtersExpanded && {
								backgroundColor: '#D1F0FF',
								border: 'none',
								'&:hover': {
									backgroundColor: '#D1F0FF',
								},
							}),
						}}
						onClick={() => setFiltersExpanded((prev) => !prev)}
						disableRipple
					>
						{t('Bookings.Filter.FilterBookings')}
					</ArbiIconButton>

					{filtersAreActive ? (
						<div className="new-bookings-filters-wrap-component__top-bar-clear">
							<Button id="clear-button" onClick={clearAllFilters} disableRipple>
								{t('Bookings.Filter.ClearAll')}
							</Button>
						</div>
					) : (
						<span className="new-bookings-filters-wrap-component__top-bar-description">
							{t('Bookings.Filter.FilterBookingsDescription')}
						</span>
					)}
				</div>

				<Fade in={!filtersExpanded} timeout={100} mountOnEnter unmountOnExit appear>
					<div className="new-bookings-filters-wrap-component__tags">
						<Stack direction="row" spacing={1} flexWrap="wrap">
							{getTags()}
						</Stack>
					</div>
				</Fade>
			</div>
			{/* Overlay */}
			{filtersExpanded && <div className="filters-overlay" onClick={() => setFiltersExpanded(false)} />}

			<NewBookingsFiltersComponent
				open={filtersExpanded}
				container={() => wrapRef.current}
				profile={profile}
				filters={filters}
				setFilters={setFilters}
				initFilters={initFilters}
				setPagination={setPagination}
				initPagination={initPagination}
				onClose={() => setFiltersExpanded(false)}
				search={search}
			/>
		</>
	);
};

export default NewBookingsFiltersWrapComponent;
